import { createSlice } from "@reduxjs/toolkit";
import {
  buyerCampaigns,
  checkProductAvailabilityQuantity,
  checkProductAvailabilityQuantityBeforeLogin,
  createInstantCampaign,
  createNewCampaign,
  deleteCampaign,
  deleteCampaignProduct,
  deleteMultipleProducts,
  duplicateCampaign,
  exportToExcel,
  getBuyerCampaigns,
  getSelectedColumnsToExport,
  getUserSavedCampaigns,
  moveProductToCampaign,
  renameCampaignName,
  searchBuyerCampaigns,
  shareCampaignDetails,
  transferCampaignToBuyer,
  updateProductQty,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  getBuyerCampaignsLoading: false,
  buyerCampaignsLoader: false,
  isQuantityLoading: false,
  error: null,
  buyerCampaignsList: [],
  isCampaignLoading: false,
  isDuplicating: false,
  isDeleting: false,
  isDeletingCampaign: false,
  filteredCampaignsList: [],
  editCampaignResponse: null,
  shareCampaignResponse: null,
  deleteCampaignResponse: null,
  duplicateCampaignResponse: null,
  selectedCampaignDetails: {},
  productQtyStatus: null,
  productQty: null,
  deleteProduct: null,
  instantCampaignLoading: false,
  isSearchCampaignLoading: false,
};

export const buyerCampaignSlice = createSlice({
  name: "buyerCampaigns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getCampaignCount

    // getbuyerCampaigns
    builder
      .addCase(getBuyerCampaigns.pending, (state) => {
        state.getBuyerCampaignsLoading = true;
        state.error = null;
      })
      .addCase(getBuyerCampaigns.fulfilled, (state, action) => {
        state.getBuyerCampaignsLoading = false;
        state.buyerCampaignsList = action.payload;
        state.filteredCampaignsList = [];
      })
      .addCase(getBuyerCampaigns.rejected, (state, action) => {
        state.getBuyerCampaignsLoading = false;
        state.error = action.payload;
        message.error("something went wrong!");
      });

    // get filtered campaigns data

    builder
      .addCase(searchBuyerCampaigns.pending, (state) => {
        state.isSearchCampaignLoading = true;
        state.error = null;
      })
      .addCase(searchBuyerCampaigns.fulfilled, (state, action) => {
        state.isSearchCampaignLoading = false;
        state.buyerCampaignsList = action.payload;
      })
      .addCase(searchBuyerCampaigns.rejected, (state, action) => {
        state.isSearchCampaignLoading = false;
        state.error = action.payload;
      });

    // edit campaign name
    builder
      .addCase(renameCampaignName.pending, (state) => {
        state.isRenamingLoading = true;
        state.error = null;
      })
      .addCase(renameCampaignName.fulfilled, (state, action) => {
        state.isRenamingLoading = false;
        state.editCampaignResponse = action.payload;
        if (action?.payload?.status == 1) {
          message.success(action.payload.message);
        } else {
          message.error(action.payload.message);
        }
      })
      .addCase(renameCampaignName.rejected, (state, action) => {
        state.isRenamingLoading = false;
        state.error = action.payload;
        message.error(action.payload.message);
      });
    // share campaign

    builder
      .addCase(shareCampaignDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(shareCampaignDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shareCampaignResponse = action.payload;
      })
      .addCase(shareCampaignDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error(
          action.payload.message ||
            "Failed to share the campaign. Please try again!",
        );
      });

    // delete campaign
    builder
      .addCase(deleteCampaign.pending, (state) => {
        state.isDeletingCampaign = true;
        state.error = null;
      })
      .addCase(deleteCampaign.fulfilled, (state, action) => {
        state.isDeletingCampaign = false;
        state.deleteCampaignResponse = action.payload;
      })
      .addCase(deleteCampaign.rejected, (state, action) => {
        state.isDeletingCampaign = false;
        state.error = action.payload;
        message.error(action.payload.message);
      });

    //duplicate campaign
    builder
      .addCase(duplicateCampaign.pending, (state) => {
        state.isDuplicating = true;
        state.error = null;
      })
      .addCase(duplicateCampaign.fulfilled, (state, action) => {
        state.isDuplicating = false;
        state.duplicateCampaignResponse = action.payload;
        if (action?.payload?.status == 1) {
          message.success(
            action?.payload?.message || "Campaign duplicated successfully!",
          );
        } else {
          message.error(action?.payload?.message);
        }
      })
      .addCase(duplicateCampaign.rejected, (state, action) => {
        state.isDuplicating = false;
        state.error = action.payload;
        message.error(action.payload.message);
      });

    //saved campaigns
    builder
      .addCase(getUserSavedCampaigns.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserSavedCampaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.savedCampaigns = action.payload;
      })
      .addCase(getUserSavedCampaigns.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    //create new campaign
    builder
      .addCase(createNewCampaign.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.campaignCreation = null;
      })
      .addCase(createNewCampaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.campaignCreation = action.payload;
        if (action?.payload?.status == 1) {
          message.success(state.campaignCreation?.message);
        } else {
          message.error(state.campaignCreation?.message);
        }
      })
      .addCase(createNewCampaign.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    //buyer campaign
    builder
      .addCase(buyerCampaigns.pending, (state, action) => {
        state.buyerCampaignsLoader = true;
        state.error = null;
        state.selectedCampaignDetails = null;
      })
      .addCase(buyerCampaigns.fulfilled, (state, action) => {
        state.buyerCampaignsLoader = false;
        state.selectedCampaignDetails = action.payload;
      })
      .addCase(buyerCampaigns.rejected, (state, action) => {
        state.buyerCampaignsLoader = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    //increase campaign product quantity
    builder
      .addCase(updateProductQty.pending, (state, action) => {
        state.isQuantityLoading = true;
        state.error = null;
        state.productQty = null;
        state.productQtyStatus = null;
      })
      .addCase(updateProductQty.fulfilled, (state, action) => {
        state.isQuantityLoading = false;
        state.productQty = action.payload;
        state.productQtyStatus = "updated";
      })
      .addCase(updateProductQty.rejected, (state, action) => {
        state.isQuantityLoading = false;
        state.error = action.payload;
      });
    //remove product campaign
    builder
      .addCase(deleteCampaignProduct.pending, (state, action) => {
        state.isDeleting = true;
        state.error = null;
        state.deleteProduct = null;
        state.productQtyStatus = null;
      })
      .addCase(deleteCampaignProduct.fulfilled, (state, action) => {
        state.isDeleting = false;
        state.deleteProduct = action.payload.message;
        state.productQtyStatus = "updated";
      })
      .addCase(deleteCampaignProduct.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      });

    // check product availability quantity
    builder
      .addCase(checkProductAvailabilityQuantity.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkProductAvailabilityQuantity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productAvailabilityQuantity = action.payload;
      })
      .addCase(checkProductAvailabilityQuantity.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // check product availability quantity before login
    builder
      .addCase(
        checkProductAvailabilityQuantityBeforeLogin.pending,
        (state, action) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addCase(
        checkProductAvailabilityQuantityBeforeLogin.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.productAvailabilityQuantity = action.payload;
        },
      )
      .addCase(
        checkProductAvailabilityQuantityBeforeLogin.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        },
      );
    // transfer campaign to another buyer
    builder
      .addCase(transferCampaignToBuyer.pending, (state, action) => {
        state.transferCampaignLoading = true;
        state.error = null;
      })
      .addCase(transferCampaignToBuyer.fulfilled, (state, action) => {
        state.transferCampaignLoading = false;
        message.success(action.payload.message);
      })
      .addCase(transferCampaignToBuyer.rejected, (state, action) => {
        state.transferCampaignLoading = false;
        message.error("Something went wrong!");
      });

    //Get the selected columns to exoprt excel
    builder
      .addCase(getSelectedColumnsToExport.pending, (state, action) => {
        state.exportColumnsLoading = true;
        state.error = null;
      })
      .addCase(getSelectedColumnsToExport.fulfilled, (state, action) => {
        state.exportColumnsLoading = false;
        state.availableColumns = action.payload.available_columns;
        state.selectedColumns = action.payload.selected_columns;
      })
      .addCase(getSelectedColumnsToExport.rejected, (state, action) => {
        state.exportColumnsLoading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message || "Error occured";
      });

    // Exporting excel
    builder
      .addCase(exportToExcel.pending, (state, action) => {
        state.isExported = true;
        state.error = null;
      })
      .addCase(exportToExcel.fulfilled, (state, action) => {
        state.isExported = false;
        state.message = action.payload.message;
      })
      .addCase(exportToExcel.rejected, (state, action) => {
        state.isExported = false;
      });

    // delete multipleproducts from campaign
    builder
      .addCase(deleteMultipleProducts.pending, (state, action) => {
        state.deleteMultipleProductLoading = true;
        state.error = null;
      })
      .addCase(deleteMultipleProducts.fulfilled, (state, action) => {
        state.deleteMultipleProductLoading = false;
        if (action?.payload?.status == 1) {
          message.success(action?.payload?.message);
        } else {
          message.error(action?.payload?.message);
        }
      })
      .addCase(deleteMultipleProducts.rejected, (state, action) => {
        state.deleteMultipleProductLoading = false;
        message.error("Something went wrong!");
      });

    builder
      .addCase(moveProductToCampaign.pending, (state, action) => {
        state.moveProductToCampaignLoading = true;
        state.error = null;
      })
      .addCase(moveProductToCampaign.fulfilled, (state, action) => {
        state.moveProductToCampaignLoading = false;
        if (action?.payload?.status == 1) {
          message.success(action?.payload?.message);
        } else {
          message.error(action?.payload?.message);
        }
      })
      .addCase(moveProductToCampaign.rejected, (state, action) => {
        state.moveProductToCampaignLoading = false;
        message.error("Something went wrong!");
      });

    builder
      .addCase(createInstantCampaign.pending, (state, action) => {
        state.instantCampaignLoading = true;
        state.error = null;
      })
      .addCase(createInstantCampaign.fulfilled, (state, action) => {
        state.instantCampaignLoading = false;
        if (action?.payload?.status == 1) {
          message.success(action?.payload?.message);
        } else {
          message.error(action?.payload?.message);
        }
      })
      .addCase(createInstantCampaign.rejected, (state, action) => {
        state.instantCampaignLoading = false;
        message.error("Something went wrong!");
      });
  },
});

export default buyerCampaignSlice.reducer;
